import React, { useMemo } from "react";
import { Row, Col, Card } from "antd";
import { Pie, measureTextWidth } from '@ant-design/plots';

const initialData = [
    {
        value: 100,
        label: "Predictions"
    }
];

const renderStatistic = (containerWidth, text, style) => {
    const { width: textWidth, height: textHeight } = measureTextWidth(text, style);
    const R = containerWidth / 2;

    let scale = 1;

    if (containerWidth < textWidth) {
        scale = Math.min(Math.sqrt(Math.abs(Math.pow(R, 2) / (Math.pow(textWidth / 2, 2) + Math.pow(textHeight, 2)))), 1);
    }

    const textStyleStr = `width:${containerWidth}px;`;
    return `<div style="${textStyleStr};font-size:${scale}em;line-height:${scale < 1 ? 1 : 'inherit'};">${text}</div>`;
};

const setChartConfig = (data) => {
    return {
        appendPadding: 10,
        data: data?.length > 0 ? data : initialData,
        angleField: 'value',
        colorField: 'label',
        radius: 1,
        innerRadius: 0.64,
        legend: {
            verticalAlign: "middle",
            align: "center",
            position: "bottom"
        },
        color: ['#69b1ff', '#b37feb', '#5cdbd3', '#91caff', '#b7eb8f'],
        meta: {
            value: {
                formatter: (v) => `${v?.toLocaleString()}`,
            },
        },
        label: {
            type: 'inner',
            offset: '-50%',
            style: {
                textAlign: 'center',
            },
            autoRotate: false,
            content: '{value}',
        },
        statistic: {
            title: {
                offsetY: -4,
                customHtml: (container, view, datum) => {
                    const { width, height } = container.getBoundingClientRect();
                    const d = Math.sqrt(Math.pow(width / 2, 2) + Math.pow(height / 2, 2));
                    const text = datum ? datum.label : 'All';
                    return renderStatistic(d, text, {
                        fontSize: 28,
                    });
                },
            },
            content: {
                offsetY: 4,
                style: {
                    fontSize: '32px',
                },
                customHtml: (container, view, datum, data) => {
                    const { width } = container.getBoundingClientRect();
                    const text = datum ? `${datum.value}` : `${data.reduce((r, d) => r + d.value, 0)}`;
                    return renderStatistic(width, text, {
                        fontSize: 32,
                    });
                },
            },
        },
        interactions: [
            {
                type: 'element-selected',
            },
            {
                type: 'element-active',
            },
            {
                type: 'pie-statistic-active',
            },
        ],
    };
};

const PredictionsByMarket = ({ data, isLoading }) => {
    const config = useMemo(() => setChartConfig(data), [data]);

    return (
        <Card title="Predictions by market">
            <Row gutter={24}>
                <Col span={24}>
                    <Pie {...config} loading={isLoading} className="p-0 m-0" />
                </Col>
            </Row>
        </Card>
    );
};

export default PredictionsByMarket;